import { AdvancedFilterModel } from '../../models/AdvancedFilterModel';
import { QueryListAction } from '../../../pillar/dashboard/store/actions/QueryListAction';
import { JobListModel } from '../../models/JobListModel';

export const ADVANCED_FILTER_ACTION = '[Submission] Advanced Filter Action';

export class AdvancedFilterAction extends QueryListAction<JobListModel> {
  constructor(module: string, modelType: { new(): JobListModel; }, public payload: {
    page: number,
    pageSize: number,
    sort?: string,
    sortDirection?: string,
    searchTerm?: string,
    model?: AdvancedFilterModel }) {
    super(module, modelType, payload);
  }
}



// WEBPACK FOOTER //
// ./src/app/submission/store/actions/AdvancedFilterAction.ts